<template>
  <div class="sales-by-location bg-white pt-4 pb-4"
       v-loading="loading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <GChart
      :settings="settings"
      type="GeoChart"
      :data="chartData"
      :options="chartOptions"
      :events="chartEvents"
    />
    <div class="mt-10">
      <div class="mb-1 px-4 outlet flex flex-row justify-between text-xs" v-for="outlet in outlets">
        <p class="name font-normal"> {{outlet.address}}, {{outlet.store_state}} </p>
        <p class="amount font-normal"> N {{numberFormat(outlet.total_amount, '0,0')}} </p>
        <p class="sales font-normal"> {{outlet.total_sales}} </p>
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'sales_by_location',
  components: {
    GChart,
  },
  computed: {
    totalSalesByLocation() {
      return this.$store.getters['Dashboard/totalSalesByLocation'] || 0;
    },

    chartData() {
      if (this.mapLevel) {
        return [
          ['Country', 'Sales'],
          ['Nigeria', this.totalSalesByLocation],
        ];
      }

      return this.$store.state.Dashboard.geo_coded_sales_location;
    },

    outlets() {
      return this.$store.state.Dashboard.sales_location;
    },
  },
  data() {
    return {
      loading: true,
      mapLevel: true,
      settings: {
        packages: ['geochart'],
        mapsApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      },
      chartEvents: {
        regionClick: (evt) => {
          if (evt.region === 'NG') {
            this.loading = true;
            this.$store.dispatch('Dashboard/addressGeoCode').then(() => {
              this.chartOptions.region = evt.region;
              this.chartOptions.resolution = 'provinces';
              this.chartOptions.displayMode = 'region';
              this.mapLevel = false;
              this.loading = false;
            });
          }
        },
        ready: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = true;
        },
      },
      chartOptions: {
        region: 'world',
        legend: 'none',
        magnifyingGlass: {
          zoomFactor: 100,
        },
        colorAxis: { minValue: 0, colors: ['#FF0000', '#00FF00'] },
      },
    };
  },
  async mounted() {
    await this.$store.dispatch('Dashboard/fetchLocationBySalesStats');
  },
};
</script>

<style scoped lang="scss">
.sales-by-location {
  height: auto;
  overflow: hidden;

  .outlet {
    .name {
      flex: 0 1 70%
    }

    .amount {
      flex: 0 1 12%;
    }

    .sales {
      flex: 0 1 12%;
    }
  }
}
</style>
